import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../util';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const dateInput: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'stretch',
  width: '100%',

  '&.readOnly': {
    input: {
      color: 'Text.fields',
      bg: 'Background.fields',
    },
  },

  '.iconInput': {
    width: '100%',
    position: 'relative',
  },

  'input:hover~.delete_date_button:not(:disabled,[aria-selected="true"]), input:hover~.delete_date_button:not(:disabled,[aria-selected="true"]) path, .delete_date_button':
    {
      position: 'absolute',
      right: '59px',
      padding: 0,
      top: 'calc(50% - 10px)',
      margin: 0,
      marginRight: 0,
      borderRadius: '100%',
      width: '20px',
      height: '20px',

      ...getColorsAndStatesByPath('buttons.icon-outline'),
    },

  input: {
    flexShrink: 1,
  },

  '& > div': {
    display: 'flex',
    gap: spacing(2),
    flexShrink: 0,
    width: 'auto',
    maxWidth: '100%',
    minWidth: 0,

    button: {
      width: '45px',
      flexShrink: 0,
    },
  },
  ...getColorsAndStatesByPath('form.fields', {
    states: {
      hover: false,
      active: false,
      focus: false,
    },
  }),

  backgroundColor: undefined,
};

export default dateInput;
